<footer [ngStyle]="{'background-color': IsLogedIn? '#002d45': 'transparent'}" >
  <div class="container">
    <div class="grid_footer">
      <div class="col1">
        <h4 id="warunki" [translation]="TranslationEnum.Translation">
          {{'warunki'|translate}}
        </h4>
        <ng-container *ngFor="let dok of tresci.links; let m = index;">
          <a  *ngIf = "dok.ProdGroup == 'b2b_warunki' && dok.Culture == tresci.jezyk" [href]="dok.Url"
            rel="nofollow" target="_blank" rel="noopener">
            {{dok.LangVal}}
          </a><br *ngIf = "dok.ProdGroup == 'b2b_warunki' && dok.Culture == tresci.jezyk" />
        </ng-container>
      </div>
      <mat-divider class="vertical mt-2 mb-2" [vertical]="true"></mat-divider>
      <div class="col2">
        <h4 id="informacje" [translation]="TranslationEnum.Translation">
          {{'informacje'|translate}}
        </h4>
        <ng-container *ngFor="let dok of tresci.links; let m = index;">
          <a  *ngIf = "dok.ProdGroup == 'b2b_informacje' && dok.Culture == tresci.jezyk" [href]="dok.Url"
            rel="nofollow" target="_blank" rel="noopener">
            {{dok.LangVal}}
          </a><br *ngIf = "dok.ProdGroup == 'b2b_informacje' && dok.Culture == tresci.jezyk" />
        </ng-container>
        
   
      </div>
    </div>
  </div>
  <div class="d-flex w-100">
    <div class="stopka_txt">
  <p class="stopka_txt1">© {{dateInFooter}} b2b.selt.com powered by
        <a href="https://www.aluprof.com" target="_blank">Aluprof</a>
      </p>
      <p class="stopka_txt2">© {{dateInFooter}} b2b.selt.com powered by
        KRS: 0000106225 NIP: 547-02-42-884 Kapitał zakładowy/wpłacony: 4 028 350 PLN,- Sąd Rejonowy w Bielsku-Białej VIII Wydział Gospodarczy Krajowego Rejestru Sądowego
  Adres do e-doręczeń: AE:PL-96706-42023-SSEVB-21 
      </p>
    </div>
    
  </div>
  <p class="pr-3 pl-3 app-version">v. {{Version}}</p>
</footer>
